import Cookies from 'js-cookie'
import { setCookieEncrypt } from '@/utils/util'

const user = {
  state: {
    showVerify: false,  // 是否显示验证码
    token: '',
    userid: '',
    // token: 'CFDD455F7AE5506962B3FBF20E3F6E1F93567719E8877732FF4733EDA9796FDC4EEAA58C09D296AE55D43A70E6AF8E59',
    // userid: 'a0c6dce9c637409e8857a70cacc0d3bc',
    userName: '',
    headImg: '',
    phone: ''
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      if (userInfo) {
        state.token = userInfo.token
        state.userid = userInfo.userid
        state.userName = userInfo.userName
        state.headImg = userInfo.headImg
        state.phone = userInfo.phone
      } else {
        state.token = ''
        state.userid = ''
        state.userName = ''
        state.headImg = ''
        state.phone = ''
      }
    },
    SET_USER_PHONE(state, val) {
      state.phone = val
    },
    SET_LOGIN_VERTIFY(state, val) {
      state.showVerify = val
    }
  },
  actions: {
    setUserIfo({ commit }, info) {
      commit('SET_USER_INFO', info)
    },
    // 用户名登录
    LoginUser({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        this._vm.$http.get('/frontLogin.do', userInfo).then(
          res => {
            if (res.success === 1) {
              let data = res.data
              commit('SET_USER_PHONE', data.phone)
              commit('SET_USER_INFO', {
                token: data.token,
                userid: data.id,
                userName: data.sessionAdminName,
                headImg: data.headimgurl,
                phone: data.phone
              })
              Cookies.set('token', data.token, { expires: 7 })

              commit('SET_LOGIN_VERTIFY', false)
              Cookies.set('showVerify', '0', { expires: 7 })

              //加密数据
              setCookieEncrypt('userid', data.id)
              setCookieEncrypt('userName', data.sessionAdminName)

              Cookies.set('headImg', data.headimgurl, { expires: 7 })

              //加密数据
              setCookieEncrypt('phone', data.phone)

              resolve()
            } else {
              // this._vm.$message.error(res.message)
              commit('SET_LOGIN_VERTIFY', true)
              Cookies.set('showVerify', '1', { expires: 7 })
              reject(res.message)
            }
          },
          error => {
            this._vm.$message.error(error.msg || '服务器异常')
          }
        )
      })
    },
    LoginOut({ commit }) {
      commit('SET_LOGIN_VERTIFY', false)
      commit('SET_USER_INFO', '')
      Cookies.remove('userid')
    }
  }
}

export default user
